import { motion } from "framer-motion";
import { ShieldCheck, User, Heart, Headphones } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const EASE = [0.22, 1, 0.36, 1];

const REVEAL = { opacity: 0, y: 30 };
const REVEAL_IN = { opacity: 1, y: 0 };
const VIEWPORT = { once: true, margin: "-60px" };
const TRANS = { duration: 0.8, ease: EASE };

const ICONS = {
  quality: ShieldCheck,
  ages: User,
  life: Heart,
  support: Headphones,
};

export default function TrustBar() {
  const { t } = useLang();

  return (
    <section className="relative bg-[#F9FAFB] pt-8 lg:pt-12 pb-2" data-testid="trust-bar">
      <div className="max-w-[1800px] mx-auto px-6 sm:px-8 md:px-12 lg:px-20">
        <motion.div
          initial={REVEAL}
          whileInView={REVEAL_IN}
          viewport={VIEWPORT}
          transition={TRANS}
          className="rounded-3xl bg-white shadow-[0_20px_50px_rgba(11,43,86,0.08)]"
        >
          <div className="no-scrollbar flex lg:grid lg:grid-cols-4 overflow-x-auto snap-x snap-mandatory lg:overflow-visible">
            {t.trust.map((item, i) => {
              const Icon = ICONS[item.key];
              return (
                <div
                  key={item.key}
                  data-testid={`trust-item-${item.key}`}
                  className={`snap-start shrink-0 w-[82%] sm:w-1/2 lg:w-auto flex items-center gap-4 px-7 py-8 lg:px-8 ${
                    i !== 0 ? "lg:border-l lg:border-mobix-mauve/20" : ""
                  }`}
                >
                  <span className="shrink-0 flex h-16 w-16 items-center justify-center rounded-full border border-mobix-mauve/30">
                    <Icon size={26} strokeWidth={1.5} className="text-mobix-navy" />
                  </span>
                  <div>
                    <p className="text-sm font-bold uppercase tracking-wide text-mobix-orange">{item.title}</p>
                    <p className="mt-1 text-sm text-mobix-navy/80 leading-snug">{item.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
